import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import FilterComponent from '../Common/FilterComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import VendorCommon from './VendorCommon';
import { GetApiMethod, CheckPropertyExistOrNot } from '../../core/services/apiService';

const VendorTable = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(true);

    const fetchUsers = async () => {
        setLoading(true);
        const response = await GetApiMethod('admin/vendor');
        setData(response.data.data);
        setShowLoader(false);
        setLoading(false);
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const columns: any = [
        {
            name: 'Name',
            width: '15%',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'name'),
            sortable: true,

        },
        {
            name: 'Domain',
            width: '25%',
            selector: (row: any) => row['domain'],
            cell: (row: any) => CheckPropertyExistOrNot(row, 'domain') !== "-" ? <a href={"https://" + row.domain + process.env.REACT_APP_DOMAIN_URL} target="_blank">{row.domain}{process.env.REACT_APP_DOMAIN_URL}</a> : "-",
            sortable: true,
            style: {
                lineHeight: '1.4',
                paddingBottom: '3px',
                paddingTop: '3px'
            }
        },
        // {
        //     name: 'Logo',
        //     cell: (row: any) => <img
        //         alt=""
        //         src={row.logo}
        //         height="auto"
        //         style={{maxWidth : 100}}
        //         className="d-inline-block align-top"
        //     ></img>,
        //     style: {
        //         paddingTop: '8px',
        //         paddingBottom: '8px',
        //     },
        // },
        {
            name: 'Max Locations',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'maxLocations'),
            sortable: true,
        },
        {
            name: 'Max Agents',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'maxAgents'),
            sortable: true,
        },
        {
            name: 'Call Timeout',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'call_timeout'),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row: any) => ((CheckPropertyExistOrNot(row, 'isActive') === true ? "Active" : (CheckPropertyExistOrNot(row, 'isActive') === false ? "Inactive" : "-"))),
            sortable: true,
        },
        {
            name: 'Kiosk Motion Notification Video Timeout',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'notification_timeout'),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: any) => (
                <div>
                    <Link to={'/customer/edit'} state={{ id: row._id, name: row.name, domain: row.domain, logo: row.logo, maxLocations: row.maxLocations, maxAgents: row.maxAgents, agentCount: row.agent_count, locationCount: row.location_count, callTimeout: row.call_timeout, notification_timeout: row.notification_timeout, isActive: row.isActive, is_active: row.isActive }}><i className="fa fa-edit text-primary m-1" style={{ fontSize: 25 }}></i></Link>
                </div>
            )
        },

    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={(e: any) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);


    const filteredItems = data.filter(
        (item: any) =>
            JSON.stringify([
                item.name, item.domain, (item.isActive ? "Active" : "Inactive"),
                item.maxLocations, item.maxAgents, item.call_timeout, item.notification_timeout
            ])
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    return (
        <>
            <Container fluid  >
                <div className="mt-3">
                    <VendorCommon heading="Customer" action="Add" data={filteredItems} columns={columns} subHeaderComponent={subHeaderComponent} showLoader={showLoader} />
                </div>
            </Container>
        </>
    )

}
export default VendorTable;